























import { Component, Vue } from 'vue-property-decorator'
import {getLocalItem} from '@/utils'
import  NoData from '@/components/NoData'

@Component({
    components:{
        NoData
    }
})
export default class ManufacturTechnique  extends Vue {
  private pdfUrl:any=null
  created(){
      this.pdfUrl=getLocalItem('productionProcessUrl')
  }
  mounted(){
      const that = this
      setTimeout(function(){
          that.pdfUrl=getLocalItem('productionProcessUrl')
      })
  }
}
